import React from "react";
import { useSize } from "@umijs/hooks";
import cardBg from "assets/images/bg-card.png";

interface AppCardProps {
  title?: string;
  isShort?: boolean;
}

const AppCard: React.FC<AppCardProps> = ({
  title,
  isShort = false,
  children,
}) => {
  const [{ width: w = 0, height: h = 0 }, ref] = useSize<HTMLDivElement>();

  const longW = isShort ? w : w - h * 1.45;

  return (
    <div className="h-full flex flex-col">
      <div
        className="relative font-s font-bold text-2xl px-4 pb-1"
        ref={ref}
        style={{ maxWidth: "20vw" }}
      >
        <svg
          className="absolute left-0 bottom-0"
          width="100%"
          height="45%"
          viewBox={`0 0 ${w} ${h * 0.45}`}
        >
          <defs>
            <linearGradient id="titleColor" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style={{ stopColor: "#52abdc" }} />
              <stop offset="100%" style={{ stopColor: "#254e97" }} />
            </linearGradient>
          </defs>
          <path
            d={`M0 ${h * 0.45} h${longW - h * 0.35} L${longW} 0 h${-(
              longW -
              h * 0.35
            )} Z`}
            fill="url(#titleColor)"
          />
          {isShort ||
            [0, 1, 2].map((i) => (
              <path
                key={i}
                d={`M${w - h * 0.45 * i} 0 h${-h * 0.25} l${-h * 0.35} ${
                  h * 0.45
                } h${h * 0.25} Z`}
                fill="#233c8b"
              />
            ))}
        </svg>
        <span className="relative">{title}</span>
      </div>
      <div
        className="flex-auto relative pt-1"
        style={{
          background: isShort ? "none" : `url(${cardBg}) center/100% 100%`,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default AppCard;
